<script>
	import { createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
	import { sortById, groupSort } from '../utils/Sort.svelte';
    import { warning } from 'ionicons/icons/index.mjs';

    export let location;
    export let settings;
    export let map;
    let latitude = "";
    let longitude = "";

    const dispatch = createEventDispatcher();
    function sendMessage(message) {
        dispatch('message', message);
    }

    function findHandler(e) {
		e.currentTarget.blur();
        sendMessage({
            type: "context",
            data: {
                lat: Number(latitude),
                lng: Number(longitude)
            }
        })
        map.flyTo({center: [longitude, latitude], zoom: 18});
    }
</script>

<div in:fade>
    <div class="tile tile-centered pl-2 pr-2">
        <div class="tile-content">
            <div class="divider" data-content="FIND LOCATION"></div>
        </div>
    </div>
    <div class="pl-2 pr-2">
    <label class="form-label" for="lat">Latitude</label>
    <input class="form-input" bind:value={latitude} type="text" id="latitude">
    <label class="form-label" for="lng">Longitude</label>
    <input class="form-input mb-2" bind:value={longitude} type="text" id="description">
    <button class="btn btn-primary mt-2 mb-2" style="width:100%;" on:click={findHandler}>Find</button>
    </div>
    <div class="tile tile-centered pl-2 pr-2 mt-2">
        <div class="tile-content">
            <div class="divider" data-content="GEOLOCATION"></div>
        </div>
    </div>
    {#if location.enabled}
        <table class="table table-striped light">
            <tbody>
                {#each Object.keys(location) as key}
                    {#if location[key]}
                        <tr>
                            <td>{ key }</td>
                            <td>{ location[key] }</td>
                        </tr>
                    {/if}
                {/each}
                {#if settings.offset}
                    <tr>
                        <td>Offset Distance</td>
                        <td>{ settings.distance }</td>
                    </tr>
                    <tr>
                        <td>Offset Bearing</td>
                        <td>{ settings.bearing }</td>
                    </tr>
                {/if}
            </tbody>
        </table>
    {:else}
        <div class="empty">
            <div class="empty-icon">
                <i class="svg">{@html warning.md}</i>
            </div>
            <p class="empty-title h5">No location data</p>
        </div>
    {/if}
</div>

<style>
    ::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
    }
    .empty .empty-icon {
        width: 150px;
        margin: auto;
    }
    .empty .empty-title {
        margin-top: 0;
        color: black;
    }
</style>